import type { NotaAdesiva } from 'service/api'

/** Onde as notas se prendem: a um registro ou ao dia inteiro do funcionário. */
export type AncoraNota =
    | { registroId: number }
    | {
          funcionarioId: number
          /** `YYYY-MM-DD` ou ISO — só o dia conta. */
          data: string
      }

export interface EstadoIconeNota {
    tipo: 'vazio' | 'notas' | 'internas'
    quantidade: number
}

/** Monta `registro|<id>` para nota de registro e `funcionarioId|YYYY-MM-DD|dia` para nota do dia. */
export function montarChaveAncora(ancora: AncoraNota) {
    if ('registroId' in ancora) return `registro|${ancora.registroId}`
    return `${ancora.funcionarioId}|${ancora.data.slice(0, 10)}|dia`
}

function extrairAncora(nota: NotaAdesiva): AncoraNota {
    return nota.registroId
        ? { registroId: nota.registroId }
        : { funcionarioId: nota.funcionarioId, data: nota.data }
}

/** Agrupa as notas pela {@link montarChaveAncora} da âncora a que pertencem. */
export function agruparPorAncora(notas: NotaAdesiva[]) {
    const grupos = new Map<string, NotaAdesiva[]>()

    for (const nota of notas) {
        const chave = montarChaveAncora(extrairAncora(nota))
        grupos.set(chave, [...(grupos.get(chave) ?? []), nota])
    }

    return grupos
}

/** Retorna o ícone das notas de uma âncora: cadeado quando todas são internas. */
export function calcularEstadoIcone(notas: NotaAdesiva[]): EstadoIconeNota {
    if (!notas.length) return { tipo: 'vazio', quantidade: 0 }

    const isTodasInternas = notas.every(nota => !nota.visivelFuncionario)

    return {
        tipo: isTodasInternas ? 'internas' : 'notas',
        quantidade: notas.length,
    }
}
